import { defaultCurrency } from "@zapier/currency/esm/hooks/useCurrencies";
import type { Currency } from "@zapier/currency/esm/types";

import { formatPrice } from "./formatPrice";
import { formatPriceWithCurrencySymbol } from "./formatPriceWithCurrencySymbol";
import { PriceFormattingOptions } from "./types";

/**
 * Applies currency multiplier and formats price.
 */
export const formatPriceToBeInCurrency = (
  price: number,
  currency: Currency = defaultCurrency,
  includeSymbol = true,
  formattingOptions: Partial<PriceFormattingOptions> = {}
) => {
  const adjusted = price * currency.multiplier;

  return includeSymbol
    ? formatPriceWithCurrencySymbol(
        adjusted,
        formattingOptions,
        currency.symbol
      )
    : formatPrice(adjusted, formattingOptions);
};
